import React from 'react';
import Table from '../../components/ui/Table.jsx';
import Badge from '../../components/ui/Badge.jsx';
import { Link } from '../../router.jsx';
import { useApi } from '../../hooks/useApi.js';

export default function StudentRequests() {
  const [query, setQuery] = React.useState('');
  const [offset, setOffset] = React.useState(0);
  const limit = 25;
  const path = `/api/requests?limit=${limit}&offset=${offset}&q=${encodeURIComponent(query)}`;
  const { data, loading, error } = useApi(path, [query, offset]);
  const items = data?.items || [];
  const columns = [
    { key: 'id', label: 'Request' },
    { key: 'remove', label: 'Remove' },
    { key: 'add', label: 'Add' },
    { key: 'date', label: 'Submitted' },
    { key: 'status', label: 'Status' }
  ];

  const tableData = items.map((req) => ({
    id: <Link to={`/student/requests/${req.id}`}>REQ-{req.id}</Link>,
    remove: req.remove_course || '—',
    add: req.add_course || '—',
    date: req.submit_date || '—',
    status: renderStatus(req)
  }));

  const filters = (
    <input
      className="input table-search"
      type="search"
      placeholder="Search by course"
      value={query}
      onChange={(event) => {
        setQuery(event.target.value);
        setOffset(0);
      }}
    />
  );

  const pagination = {
    offset,
    limit,
    hasNext: items.length === limit,
    onPageChange: setOffset
  };

  return (
    <div className="page">
      <div className="page-header">
        <div>
          <h1>Course Change Requests</h1>
          <p className="subtle">Track approvals from advisors and the chair.</p>
        </div>
        <Link to="/student/requests/new" className="btn btn-primary">New Request</Link>
      </div>
      {error ? <div className="alert error">{error}</div> : null}
      {loading ? (
        <p className="subtle">Loading...</p>
      ) : (
        <Table
          columns={columns}
          data={tableData}
          filters={filters}
          pagination={pagination}
          emptyMessage="No requests found."
        />
      )}
    </div>
  );
}

function renderStatus(req) {
  if (req.status === 1 && req.advisor_decision === 0 && req.chair_decision === 0) {
    return <Badge tone="warning">Pending</Badge>;
  }
  if (req.status === 1 && req.advisor_decision === 1 && req.chair_decision === 0) {
    return <Badge tone="info">Chair Review</Badge>;
  }
  if (req.status === 0 && req.chair_decision === 1) {
    return <Badge tone="success">Approved</Badge>;
  }
  if (req.status === 0 && req.advisor_decision === 0) {
    return <Badge tone="error">Declined</Badge>;
  }
  return <Badge tone="info">Closed</Badge>;
}
